export const iframeSizes: { [key: string]: number } = {
  "full width": 0.94,
  "medium width": 0.85,
  narrow: 0.7,
  "very narrow": 0.58,
};
